import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getTenantConfig, DEFAULT_TENANT_ID } from '../../config/tenants';
import type { TenantConfig, TenantId } from '../../config/tenants';
import type { RootState } from '../../types';

export interface ClientState {
  tenantId: TenantId;
}

const initialState: ClientState = {
  tenantId: DEFAULT_TENANT_ID,
};

export const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    setTenantId: (state, action: PayloadAction<TenantId>) => {
      state.tenantId = action.payload;
    },
  },
});

export const { setTenantId } = clientSlice.actions;

export const selectTenantId = (state: RootState): TenantId =>
  state.client.tenantId;

export const selectTenantConfig = (state: RootState): TenantConfig =>
  getTenantConfig(state.client.tenantId);

export default clientSlice.reducer;
